var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-from-square 1",
    clipPath: "url(#clip0_217_1527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.06275 6.4957C3.633 6.04879 3.648 5.3388 4.0965 4.91057L7.161 1.98544C7.6395 1.50789 8.29875 1.23585 9 1.23585C9.70125 1.23585 10.3605 1.50789 10.8563 2.00189L13.9028 4.91057C14.3513 5.3388 14.367 6.04804 13.9365 6.4957C13.716 6.72589 13.4205 6.84098 13.1243 6.84098C12.8438 6.84098 12.564 6.73784 12.3458 6.52933L10.1243 4.40835V12.4461C10.1243 13.0657 9.621 13.5671 8.99925 13.5671C8.3775 13.5671 7.87425 13.0657 7.87425 12.4461V4.40835L5.65275 6.52933C5.20425 6.95756 4.4925 6.94262 4.06275 6.4957ZM15.375 7.58833C14.7533 7.58833 14.25 8.0898 14.25 8.70935V14.6882C14.25 15.718 13.4085 16.5565 12.375 16.5565H5.625C4.5915 16.5565 3.75 15.718 3.75 14.6882V8.70935C3.75 8.0898 3.24675 7.58833 2.625 7.58833C2.00325 7.58833 1.5 8.0898 1.5 8.70935V14.6882C1.5 16.9549 3.35025 18.7986 5.625 18.7986H12.375C14.6498 18.7986 16.5 16.9549 16.5 14.6882V8.70935C16.5 8.0898 15.9968 7.58833 15.375 7.58833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.9364,
    fill: "white",
    transform: "translate(0 0.862178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.c79889582ddbec4a48264080e0507328.svg";
export { ForwardRef as ReactComponent };